export const initialAWBState = {
  data:[],
  loading:false
}